var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Icons","transform":"translate(-267.000000, -776.000000)","fill":"#FFFFFF"},React.createElement("path",{"d":"M267,788 L285,788 L285,786 L267,786 L267,788 L267,788 Z M267,783 L285,783 L285,781 L267,781 L267,783 L267,783 Z M267,776 L267,778 L285,778 L285,776 L267,776 L267,776 Z","id":"burger"})))]);
}

Burger.defaultProps = {"width":"18px","height":"12px","viewBox":"0 0 18 12","version":"1.1"};

module.exports = Burger;

Burger.default = Burger;
